import { Link } from "@quintype/components";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SvgIconHandler } from "../svg-icon-hadler";
import "./signin-button.m.css";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";

function SigninButton() {
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [redirectURL, setRedirectUrl] = useState("");
  useEffect(() => {
    setRedirectUrl(window.location.href);
  }, []);
  const signinHandler = () => {
    if (window?.dataLayer) pushEventToDataLayer("SSO_Page_Open");

    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;
  };
  return (
    <div styleName="wrapper" onClick={signinHandler}>
      <Link styleName="signin-btn" targer="_blank">
        <SvgIconHandler type="my_account_white" width="10.31px" height="11.61px" />
        Sign in
      </Link>
    </div>
  );
}

export default SigninButton;
